import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import 'typeface-rubik';

import AppWithUserLogin from './AppWithUserLogin';
import gtmSelector from './selectors/gtmSelector';

const tagManagerArgs = {
  gtmId: gtmSelector.select(),
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(<AppWithUserLogin />, document.getElementById('root'));
